import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectSelectedItems } from '../object-tree-store/selects';
import { selectCatalog, selectCatalogSettings } from './../catalog-store/selectors';
import { TimePickerState } from './state';

export const selectTimePicker = createFeatureSelector<TimePickerState>('timePicker');

export const selectStartDate = createSelector(
  selectTimePicker,
  timePicker => timePicker.startDate
)

export const selectEndDate = createSelector(
  selectTimePicker,
  timePicker => timePicker.endDate,
)

export const selectAvailabilityPlanId = createSelector(
  selectTimePicker,
  timePicker => timePicker.availabilityPlanId,
)

export const selectQuantity = createSelector(
  selectTimePicker,
  timePicker => timePicker.quantity
)

export const selectPreparationMinutes = createSelector(
  selectTimePicker,
  timePicker => timePicker.preparationMinutes
)

export const selectFollowUpMinutes = createSelector(
  selectTimePicker,
  timePicker => timePicker.followUpMinutes
)

export const selectRecurrenceRule = createSelector(
  selectTimePicker,
  timepicker => timepicker.recurrenceRule
)

export const selectTimePickerErrors = createSelector(
  selectTimePicker,
  timePicker => timePicker.errors
)

export const selectApplicableAvailabilityPlans = createSelector(
  selectCatalog,
  selectSelectedItems,
  (catalog, items) => items.length && catalog.availabilityPlans
    ? catalog.availabilityPlans.filter(plan => items.filter(i => i.item.availabilityPlanIds?.some(p => p === plan.id)).length === items!.length)
    : []
)

export const selectShowSpotPicker = createSelector(
  selectCatalogSettings,
  selectApplicableAvailabilityPlans,
  (settings, plans) => settings.Feature_ReservationUsedTimeSlots && plans.some(p => p.startSelection === 'SpotPicker')
)
